import { useCallback } from 'react';
import { useIntl } from 'react-intl';

export type DateIntlFormatter = (date: string) => string;

export const useIntlFormatDate = (): DateIntlFormatter => {
  const intl = useIntl();

  return useCallback<DateIntlFormatter>(
    (rawDate: string) => {
      const date = new Date(rawDate);

      return `${intl.formatDate(date, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })}  ${intl.formatDate(date, { hour: '2-digit', minute: '2-digit' })}`;
    },
    [intl],
  );
};
